import Application from 'wgnet-awesomejs';
import initInputNumberCheck from 'wgnet-awesomejs/lib/number_input_check';
import $ from 'jquery';
import URI from 'urijs';
import Spinner from 'spin.js';

import themeSetting from 'registration/js/lib/theme_settings';

import _ from 'underscore';
import BaseInput from './input';

const SPINNER = Symbol('spinner');

const BaseCaptchaField = BaseInput.extend({
    name: 'captcha-field',
    fieldName: 'captcha',

    defaultSpinnerOptions: {
        lines: 11,
        length: 5,
        width: 2,
        radius: 5,
        corners: 1,
        rotate: 0,
        direction: 1,
        color: '#fff',
        speed: 1.1,
        trail: 60,
        shadow: false,
        hwaccel: false,
        className: 'spinner',
        zIndex: 2e9,
        top: '50%',
        left: '50%',
    },

    spinner() {
        this[SPINNER] = this[SPINNER] || new Spinner(this.spinnerOptions);
        return this[SPINNER];
    },

    beforeInitialize(options = {}) {
        options['pow-allowed'] = options['pow-allowed'] === 'true' || false;
    },
    updateCaptcha() {
        this.$form.trigger('reload.challenge.captcha');
        return false;
    },
    onInput: true,
    onKeyUp: true,
    onKeyDown(event = {}) {
        const key = event.which || event.keyCode;

        if (key === 13) {
            this.$el.trigger('submit');
            return false;
        }

        return true;
    },
    afterInitialize(...args) {
        BaseInput.prototype.afterInitialize.apply(this, args);
        if (this.enableInputNumberCheck !== false) {
            initInputNumberCheck(this.$('input'), this);
        }
        this.$form.on('captcha.show', _.bind(this.show, this));
        this.$form.on('captcha.hide', _.bind(this.hide, this));
        this.$image = this.$('.js-captcha-image');
        this.$reloadBtn = this.$('.js-captcha-reload');
        this.$spinnerContainer = this.$('.js-captcha-spinner-container');
        this.isWaiting = false;
        this.spinnerOptions = _.extend({}, this.defaultSpinnerOptions);
        this.delegateEvents({
            'click .js-captcha-reload': 'updateCaptcha'
        });
    },
    getImageSrc({ url }) {
        const theme = themeSetting.captcha || '';
        return URI(url).addSearch('theme', theme).toString();
    },
    startWaiting() {
        if (this.isWaiting) {
            return;
        }
        this.isWaiting = true;

        this.$spinnerContainer.css('background', 'rgba(0, 0, 0, 0.5)');
        this.$reloadBtn.addClass('is-waiting');
        this.spinner().spin(this.$spinnerContainer[0]);
    },
    stopWaiting() {
        if (!this.isWaiting) {
            return;
        }
        this.isWaiting = false;

        this.spinner().stop();
        this.$spinnerContainer.css('background', 'transparent');
        this.$image.css('opacity', '1');
        this.$reloadBtn.removeClass('is-waiting');
    },
    show(event, data) {
        this.startWaiting();

        const newUrl = this.getImageSrc(data);

        const newImg = document.createElement('img');
        newImg.className = 'js-captcha-image';

        $(newImg).on('load', () => {
            this.$image.remove();
            this.$spinnerContainer.before(newImg);
            this.$image = $(newImg);

            this.stopWaiting();
        });

        $(newImg).on('error', () => {
            this.stopWaiting();
        });

        newImg.src = newUrl;
        this.$input.val('');
        this.$el.removeClass('hidden');
        Application.trigger('closesuggestdialog');
    },
    hide() {
        this.$fieldset.addClass('hidden');
        this.$image.removeAttr('src');
        this.stopWaiting();
    }
});
export default BaseCaptchaField;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/base/fields/captcha.js